import { Box } from '@chakra-ui/react';
import React from 'react';
import { Outlet } from 'react-router-dom';

import LogoLoader from 'components/Loader/LogoLoader';
import { useFetchIntegrationList } from 'hooks/integrations/useFetchIntegrationList';

const Integrations: React.FC<unknown> = () => {
  const { status: integrationListStatus } = useFetchIntegrationList();

  if (integrationListStatus === 'loading') return <LogoLoader />;

  return (
    <Box
      position="relative"
      mx={{ base: 0, sm: 4, md: 6 }}
      my={{ base: 4, md: 6 }}
      bg="white"
      minHeight="100%"
      padding={4}
      borderRadius="lg"
    >
      <Box minHeight="100%">
        <Outlet />
      </Box>
    </Box>
  );
};
export default Integrations;
